import { defineComponent, h } from 'vue'
import { mapState } from 'vuex'

export default (component: any) => defineComponent({
  computed: {
    ...mapState({
      selectedStatus: (state: any) => state.selections.selectedStatus,
      questions: (state: any) => state.questions,
    }),
  },
  render() {
    const questions = this.questions
      .filter((question: any) => question.status === this.selectedStatus)

    return h(component, {
      ...this.$attrs,
      selectedStatus: this.selectedStatus,
      questions,
    })
  },
})
